export default __webpack_public_path__ + "static/Main-03ca9cd9dd19a575dfb08c5c81a61c8e.png";